import { Injectable } from '@angular/core';
import { Observable, Subject, tap } from 'rxjs';
import { DataService } from './../../../shared/services/data.service';
import { ResponseModel } from './../../../shared/models/response-model.model';
import { TimeTtacking} from '../manufacturing-process/manufacturing-process.model'

@Injectable({
  providedIn: 'root'
})
export class ManufacturingProcessService {
  public previouscellClickedId: number = null;
  public isCardViewManufacturingProcess:boolean;
  constructor(public service: DataService) { }
  getAll(data ,isInwardAndOutwardJoinView):Observable<ResponseModel>{
    let url = "api/App/JobworkQueueItem/getAllJobworkQueueItemInwardOutward";
    if(!isInwardAndOutwardJoinView)
      url = "api/app/jobworkqueueitem/getSingleGridJobworkQueue";
    return this.service.post(url,data, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getMultiGridJobworkQueue(data):Observable<ResponseModel>{
     let url = "api/app/jobworkqueueitem/getMultiGridJobworkQueue";
    return this.service.post(url,data, true,null,false).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getAllClosingDetailData(data): Observable<ResponseModel> {
    let url = "api/app/jobworkqueue/getclosingdetailsjobworkqueue";
    return this.service.post(url,data,true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getSingleGridJobworkQueue(data):Observable<ResponseModel>{
    let url = "api/App/JobworkQueueItem/getSingleGridJobworkQueue";
    return this.service.post(url,data, true,null,false).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getCardViewJobworkQueue(data):Observable<ResponseModel>{
    let url =  "api/app/jobworkqueue/getCardViewJobworkQueue";
    return this.service.post(url,data, true,null,false).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  insertUpdateJobworkqueueTimeTracking(data:TimeTtacking):Observable<ResponseModel>{
    let url =  "api/app/jobworkqueue/insertupdatejobworkqueuetimetracking";
    return this.service.post(url,data, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getJobworkQueItems(id):Observable<ResponseModel>{
   const data={id};
    let url = "api/App/jobworkqueue/getjobworkqueueitembyid";
    return this.service.post(url,data, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getClosingTimeDropdown(data):Observable<ResponseModel>{
    let url = "api/app/dropdown/getclosingtimingdropdown";
    return this.service.post(url,data, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
}
